<template>
  <div class="login-page">
    <div class="login-header">
      <div class="logo-circle"><span>CRM</span></div>
      <h1 class="app-name">OA系统</h1>
      <p class="app-desc">智能办公 · 高效协同</p>
    </div>
    <div class="login-form">
      <van-field v-model="form.username" placeholder="请输入账户" left-icon="manager-o" clearable class="login-field" />
      <van-field v-model="form.password" type="password" placeholder="请输入密码" left-icon="lock" clearable class="login-field" />
      <van-field v-model="form.captcha" placeholder="请输入验证码" left-icon="shield-o" clearable class="login-field">
        <template #button>
          <img v-if="captchaBase64" :src="captchaBase64" @click="refreshCaptcha" class="captcha-img" />
          <van-button v-else size="small" type="primary" @click="refreshCaptcha">获取验证码</van-button>
        </template>
      </van-field>
      <van-button type="primary" block round class="login-btn" @click="handleLogin" :loading="loading">登 录</van-button>
    </div>
    <p class="login-footer"><a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">吉ICP备2026007743号</a></p>
  </div>
</template>

<script>
import { login, captcha } from '@/api'
export default {
  name: 'Login',
  data() { return { form: { username:'', password:'', captcha:'', captchaId:'' }, captchaBase64:'', loading:false } },
  mounted() { this.refreshCaptcha() },
  methods: {
    async refreshCaptcha() {
      try { const res = await captcha({ captchaId: this.form.captchaId }); if(res.code===0){ this.form.captchaId=res.data.captchaId; this.form.captcha=''; this.captchaBase64=process.env.VUE_APP_BASE_API+res.data.picPath } } catch(e) {}
    },
    async handleLogin() {
      if(!this.form.username){this.$toast('请输入账户');return}
      if(!this.form.password){this.$toast('请输入密码');return}
      if(!this.form.captcha){this.$toast('请输入验证码');return}
      this.loading=true
      try{ await this.$store.dispatch('user/LoginIn',this.form); this.$toast.success('登录成功'); this.$router.push('/dashboard') }catch(e){this.refreshCaptcha()}finally{this.loading=false}
    }
  }
}
</script>

<style scoped>
.login-page { min-height:100vh; background:#fff; display:flex; flex-direction:column; align-items:center; padding:0 32px; }
.login-header { text-align:center; padding-top:80px; padding-bottom:40px; }
.logo-circle { width:72px; height:72px; border-radius:18px; margin:0 auto 16px; background:#2F88FF; display:flex; align-items:center; justify-content:center; box-shadow:0 8px 24px rgba(47,136,255,0.25);
  span { color:#fff; font-size:22px; font-weight:800; letter-spacing:2px; }
}
.app-name { font-size:22px; font-weight:700; color:#171A1D; margin-bottom:4px; }
.app-desc { font-size:13px; color:#A0A4AE; letter-spacing:1px; }
.login-form { width:100%; }
.login-field { margin-bottom:12px; border-radius:8px; background:#F5F6FA; border:1px solid transparent; transition:border 0.2s;
  &:focus-within { border-color:#2F88FF; background:#fff; }
}
.captcha-img { height:36px; width:100px; border-radius:4px; }
.login-btn { margin-top:24px; height:48px; font-size:16px; font-weight:600; letter-spacing:4px; background:#2F88FF; border:none; border-radius:8px; box-shadow:0 4px 12px rgba(47,136,255,0.3); }
.login-footer { margin-top:auto; padding-bottom:32px; color:#A0A4AE; font-size:12px; }
</style>
